/**
 * ProgramHeader.js — Sprint 1 Workstream B
 *
 * Persistent strip rendered at the top of every page once the user has
 * picked a program. Shows current program badge + "Switch Program"
 * button so customers can flip between MOSAIC Practice and MOSAIC
 * Summative without losing their place.
 *
 * Design contract: /app/design_guidelines.md §5
 */
import { BookOpen, ShieldCheck, RefreshCw } from "lucide-react";
import { useProgram } from "../../contexts/ProgramContext";

const ICON_MAP = { BookOpen, ShieldCheck };

export default function ProgramHeader({ onSwitchProgram }) {
  const { program, clearProgram } = useProgram();
  if (!program) return null;

  const Icon = ICON_MAP[program.icon] || BookOpen;

  const handleSwitch = () => {
    if (onSwitchProgram) onSwitchProgram();
    else clearProgram();
  };

  return (
    <div
      className={`w-full border-b border-mosaic-border-soft bg-white`}
      data-testid="program-header-root"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between gap-4">
        <div
          className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-md ${program.bgLightClass} ${program.accentClass}`}
          data-testid="program-header-badge"
        >
          <Icon className="w-4 h-4" aria-hidden="true" />
          <span className="font-medium text-sm">{program.name}</span>
        </div>

        <button
          type="button"
          onClick={handleSwitch}
          className="inline-flex items-center gap-1.5 text-xs sm:text-sm text-mosaic-ink-2 hover:text-mosaic-ink hover:bg-mosaic-bg-subtle px-2.5 py-1.5 rounded-md transition-colors"
          data-testid="program-header-switch-btn"
          title="Switch to a different MOSAIC program"
        >
          <RefreshCw className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Switch Program</span>
          <span className="sm:hidden">Switch</span>
        </button>
      </div>
    </div>
  );
}
